import { DownloadService } from "../downloadService/download.service"
import { DownloadDelegate } from "../downloadService/download.delegate"
import { HttpProviderFactory } from '../http/http-provider.factory';
import { SpinnerService } from '../SpinnerService/spinner.service';
import { IAppConfig } from '../http/types/IApplicationConfig';

export class DownloadServiceFactory
{
    static create(config: IAppConfig, spinnerService?: SpinnerService): DownloadService
    {
        const httpProvider = HttpProviderFactory.createHttpProvider(config, spinnerService);
        const delegate = new DownloadDelegate(httpProvider);

        return new DownloadService(delegate);
    }
}